exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#search-results[data-v-a5973c2a] {\n  margin: 1rem;\n}\n", ""]);
